import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowStretchBox16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowStretchBox16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 3h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1M1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm4.584 4.5 1.27 1.27a.5.5 0 0 1-.708.706l-2.12-2.121L3.671 8l.353-.353 2.121-2.122a.5.5 0 1 1 .708.708L5.587 7.5h4.819l-1.26-1.26a.5.5 0 1 1 .708-.706l2.12 2.121.354.354-.353.353-2.121 2.122a.5.5 0 0 1-.708-.708L10.423 8.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowStretchBox16);
